module.exports = __webpack_public_path__ + "static/img/icon4.36459017.png";